if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // 14-09-2026: bound once so add/removeEventListener target the same
        // reference (an inline arrow in show()/hide() would never unbind).
        this.onKeyDown = this.onKeyDown.bind(this);
      }

      hide() {
        super.hide();
        document.removeEventListener('keydown', this.onKeyDown);
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        document.addEventListener('keydown', this.onKeyDown);
      }

      // 14-09-2026: left/right arrow keys drive the same prev/next buttons
      // the lightbox nav already uses, so the disabled-at-the-ends logic and
      // the scroll/centering behaviour stay in one place (SliderComponent).
      onKeyDown(event) {
        if (event.code !== 'ArrowLeft' && event.code !== 'ArrowRight') return;
        const button = this.querySelector(
          `.product-media-modal__nav button[name="${event.code === 'ArrowRight' ? 'next' : 'previous'}"]`
        );
        if (button && !button.disabled) button.click();
        event.preventDefault();
      }

      showActiveMedia() {
        const targetMediaId = this.openedBy.getAttribute('data-media-id');

        // 13-09-2026: also toggle `.active` on the .product-media-modal__slide
        // wrapper (added for the prev/next buttons), not just the media
        // element itself. `.product-media-modal__content > *:not(.active)`
        // (mobile CSS) checks the *direct child*, which is now the wrapper —
        // without this, nothing would render on mobile screens.
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          const isActive = element.getAttribute('data-media-id') === targetMediaId;
          element.classList.toggle('active', isActive);
          const slide = element.closest('.product-media-modal__slide');
          if (slide) slide.classList.toggle('active', isActive);
        });

        const activeMedia = this.querySelector(`[data-media-id="${targetMediaId}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        // 14-09-2026: was `activeMedia.scrollIntoView({inline:'center'})`,
        // which centers the <img> ELEMENT's own box — but since each image
        // now scales down inside its slide via object-fit:contain (added
        // 14-09-2026 so photos of any aspect ratio fit without distortion),
        // narrower/shorter photos have a smaller box than the full-width
        // slide around them, so "center the image" no longer means "scroll
        // to the start of this slide" and some photos opened off-centered.
        // Every slide is exactly one full viewport-width wide (flex:0 0
        // 100%), so the slide's own offsetLeft IS the scroll position that
        // shows it edge-to-edge — simpler and independent of the image's
        // rendered size inside it.
        const activeSlide = activeMedia.closest('.product-media-modal__slide');
        const scrollContainer = this.querySelector('[id^="Slider-"]');
        if (activeSlide && scrollContainer) {
          scrollContainer.scrollLeft = activeSlide.offsetLeft;
        } else {
          activeMedia.scrollIntoView({ inline: 'center', block: 'nearest' });
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
